<template>
  <div class="wrapper">
    <div class="text-center">
      <h1 class="text-h1 font-weight-medium">
        404
      </h1>
      <h4 class="text-h4 font-weight-medium mb-3">
        Not Found
      </h4>
      <p style="max-inline-size: 50vw">
        Sorry, the page you're looking for does not exist.
      </p>
    </div>

    <v-btn
      to="/"
      color="primary"
      class="rounded mt-5 mb-12"
    >
      Back to Home
    </v-btn>
  </div>
</template>

<script setup lang="ts">
</script>

<style lang="scss">
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1.25rem;
    min-block-size: 100dvh;
  }
</style>
